export class KeyValues {

    static LEFT_ARROW = 'ArrowLeft';
    static RIGHT_ARROW = 'ArrowRight';
    static PLUS = '+';
    static MINUS = '-';
    static ENTER = 'Enter';
    static ESC = 'Escape';

    /**
     * Get the key pressed from an event.
     *
     * @param {KeyboardEvent} $event
     * @returns {string}
     */
    static getKey($event: KeyboardEvent): string {
        const key: string = $event.key;
        if (key) {
            return key;
        }

        // Fallback for safari browsers
        switch ($event.which) {
            case 13:
                return KeyValues.ENTER;
            case 27:
                return KeyValues.ESC;
            case 37:
                return KeyValues.LEFT_ARROW;
            case 39:
                return KeyValues.RIGHT_ARROW;
            case 187:
                return KeyValues.PLUS;
            case 189:
                return KeyValues.MINUS;
            default:
                return '';
        }
    }
}
